import {Icon, Modal} from "semantic-ui-react"
import {FormattedMessage} from "react-intl"


type PrivacyModalProps = {
    open: boolean
    onClose: () => void
    setContactModalOpen: (open: boolean) => void
}

export function PrivacyModal({ open, onClose, setContactModalOpen }: PrivacyModalProps) {
    return (
        <Modal className="privacy-policy" closeIcon open={open} onClose={onClose} size="large" dimmer="blurring" transition={{ animation: "fade", duration: 1 }}>

            {/* HEADER */}
            <Modal.Header as="h1"><FormattedMessage id="privacy.header"/></Modal.Header>
            <p style={{ marginBottom: 0 }}>💻&nbsp;<FormattedMessage id="privacy.header.story"/></p>

            <Modal.Content>
                {/* IMAGE */}
                <img className="privacy-image" src="https://cdn.gedcomcreator.com/assets/privacy-local.png" alt="Your data never leaves your device"/>
                {/* PROVISIONS */}
                <ol>
                    <li>
                        <p className="title"><FormattedMessage id="privacy.title.general"/></p>
                        <p><FormattedMessage id="privacy.statement.general"/></p>
                    </li>
                    <li>
                        <p className="title"><FormattedMessage id="privacy.title.storage"/></p>
                        <p><FormattedMessage id="privacy.statement.storage"/></p>
                    </li>
                    <li>
                        <p className="title"><FormattedMessage id="privacy.title.cookies.tracking"/></p>
                        <p><FormattedMessage id="privacy.statement.cookies.tracking"/></p>
                    </li>
                    <li>
                        <p className="title"><FormattedMessage id="privacy.title.error.logs"/></p>
                        <p><FormattedMessage id="privacy.statement.error.logs"/></p>
                    </li>
                    <li>
                        <p className="title"><FormattedMessage id="privacy.title.user"/></p>
                        <p><FormattedMessage id="privacy.statement.user"/></p>
                    </li>
                    <li>
                        <p className="title"><FormattedMessage id="privacy.title.contact"/></p>
                        <p><FormattedMessage id="privacy.statement.contact" values={{
                            here: <button className="reach-here" onClick={() => {
                                onClose()
                                setContactModalOpen(true)
                            }}>
                                <span style={{ fontWeight: "bold" }}>
                                    <FormattedMessage id="contact.reach.here.link"/>&nbsp;<Icon name="mail outline"/>
                                </span>
                            </button>
                        }}/></p>
                    </li>
                    <li>
                        <p className="title"><FormattedMessage id="privacy.title.changes"/></p>
                        <p><FormattedMessage id="privacy.statement.changes"/></p>
                    </li>
                </ol>
            </Modal.Content>
        </Modal>
    )
}